import { matchRoutes } from 'react-router-dom';
import vivosolRouteConfig from '../routes/vivosolRouteConfig';

function formatSlugAsLabel(value = '') {
  return value
    .split(/[-_]/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function resolveBreadcrumbLabel(breadcrumb, params = {}, labels = {}) {
  if (breadcrumb === false) {
    return null;
  }

  if (typeof breadcrumb === 'string') {
    return breadcrumb;
  }

  if (typeof breadcrumb === 'function') {
    return breadcrumb(params, labels);
  }

  if (breadcrumb?.param) {
    const { param } = breadcrumb;
    if (labels[param]) {
      return labels[param];
    }
    const value = params[param];
    if (!value) {
      return null;
    }
    return formatSlugAsLabel(value);
  }

  if (breadcrumb?.label) {
    return breadcrumb.label;
  }

  return null;
}

export function getBreadcrumbMatches(pathname) {
  return matchRoutes(vivosolRouteConfig, pathname) ?? [];
}

export function buildBreadcrumbsFromMatches(matches, labels = {}) {
  return matches
    .map((match) => {
      const handle = match.handle ?? match.route?.handle;
      const breadcrumb = handle?.breadcrumb;
      const label = resolveBreadcrumbLabel(breadcrumb, match.params, labels);

      if (!label) {
        return null;
      }

      return {
        label,
        to: handle?.breadcrumbTo,
        pathname: match.pathname,
        params: match.params,
      };
    })
    .filter(Boolean);
}
